module.exports = __webpack_public_path__ + "static/fotogemma-ea372fe713060b934e273bd1eaac2de8.png";